<template>
	<div>
		<img style="width: 100%; " src="../assets/banner/login.jpg" />
		<div class="register">
			<div class="title">
				회원가입 
			</div>
			
			
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0" class="" autocomplete="on" @submit.native.prevent="submitForm('ruleForm')">
				<!-- 服务条款 -->
				<h4>서비스 이용약관</h4> 
				<div class="agreement-box">
					<div class="height-fixed-box">
						<p>&nbsp;이용 약관<br>&nbsp;<br>&nbsp;제1조: 목적<br>&nbsp;<br>이 약관은 ㈜에스오씨피(이하 “회사”라 한다)에서 운영하는 "https://www.goroketgo.com"를(이하 "고로켓고"이라 한다) 이용함에 있어 이용자의 권리 의무 및 책임사항 및 기타 필요사항을 구체적으로 규정함을 목적으로 합니다.<br>&nbsp;<br>&nbsp;<br>제2조: 정의<br>&nbsp;<br>1. “고로켓고”는 “회사”가 “고로켓고” 서비스를 이용자에게 제공하기 위하여 제작한 가상 영업장 의미로 사용합니다.<br>2. "이용자"란 “고로켓고”에 회원 가입하여 해당 약관에 따라 “고로켓고”에서 제공하는 서비스를 받는 회원들을 말합니다.<br>3. "회원"이라 함은 본 규약을 승인한 후 인터넷을 사용해 당사가 운영하는 본 서비스를 이용하기 위해 회원 가입을 신청하고, 당사가 회원으로서 회원 가입을 인정하여 회원 ID를 발급한 자를 의미합니다. <br>또한 “고로켓고”에 개인정보를 제공하여 등록한 이용자로 “고로켓고”에서 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다.<br>4. “비회원”이라 함은 회원에 가입하지 않고 "고로켓고"가 제공하는 서비스를 이용하는 자를 말합니다.<br>5. "배송대행"은 대한민국에 거주하는 회원이 직접 해외의 전자상거래 사이트에 접속하여 구매한 물품이 “고로켓고”의 물류센터에 입고된 뒤, “고로켓고” 회원을 대신하여 물품을 검수를 거쳐 회원이 신청한 <br>대한민국의 배송처까지 운송하는 서비스를 의미한다. 배송대행은 회원의 해외 인터넷 쇼핑 “고로켓고” 이용 시 필요한 중간 배송처(해외물류 주소지)를 제공하며, 국제운송사와 회원간의 국제 배송 계약을 <br>대행하여 회원이 직접 구매/결제한 상품이 배송된 다음 항공/해운 배송 서비스(국제 운송회사 또는 항공/해운 배송 또는 국제 특급 탁송)를 통해 회원의 구입물품 수취주소까지 연결하는 중간자 역할을 유상으로 <br>제공하는 서비스를 말하며, 유상 서비스의 구성은 국제 운송료와 필요한 별도 수수료 등으로 구성되어 있으며 기타 국내 수입통관에 필요한 재 비용 등의 지불은 대행하지 않음을 명시한다.<br>6. "구매대행"은 해외상품 구입 시 필요한 주문/결제를 회원으로부터 위임받아 대행하는 것을 통칭한다.”고로켓고”에서의 구매/결제를 “고로켓고”에 명시한 관례적 계약을 통해 회원으로부터 구매 요청(권한)을 <br>위임받아 해외 판매자 (혹은 해외 인터넷 쇼핑”고로켓고”)로부터 물품을 구매/결제하는 것을 말하며 구입 대행에 따른 수수료나 책임 외의 구입 거래로 인한 다른 형태의 손익이나 거래 책임은 부담하지 않는 <br>유상 거래 서비스를 말하며 물품의 주문/결제 외의 국제운송 서비스는 배송대행 업무와 동일함을 명시한다. 구매대행의 제반 비용은 [물품 구입에 필요한 총액+국제 운송료+필요한 수수료 등으로 구성된다.&nbsp;<br>&nbsp;<br>&nbsp;<br>제3조: 회원의 가입 및 신청<br>&nbsp;<br>1. “비회원”은 “고로켓고”가 정한 가입 양식에 따라 개인 정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다.&nbsp;<br>2. 본인이 직접 온라인을 통해 회원 가입을 신청해야 합니다. 또한 회원 가입 희망자가 미성년자인 경우는 친권자의 동의를 얻은 다음 회원 가입을 신청할 수 있습니다.<br>3. “고로켓고”는 회원 가입을 신청한 이용자 중 다음 각호에 해당하지 않는 한 회원으로 등록합니다.&nbsp;<br>가. 가입신청자가 “고로켓고” 회원 자격을 상실한 적이 있는 경우<br>나. 등록 내용에 허위사실이 기재된 경우&nbsp;<br>다. 회원 가입 희망자가 미성년자로 친권자의 동의를 얻지 않은 경우<br>라. 회원 가입 희망자가 당사에 대한 채무의 지불을 게을리한 적이 있는 경우<br>마. “고로켓고”의 운영 및 서비스 제공 또는 다른 회원의 서비스 이용을 방해하거나 지장을 초래하는 행위를 한 경우<br>4. 회원은 등록사항에 변경이 있는 경우, 회원정보 수정 또는 전자우편 등의 방법으로 “고로켓고”에 대하여 그 변경사항을 알려야 한다.<br>&nbsp;<br>&nbsp;<br>제4조: 회원 탈퇴 / 회원 자격 상실<br>&nbsp;<br>1. 회원은 “고로켓고”에 언제든지 탈퇴를 요청 가능하고, “고로켓고”는 회원의 물품이 통관/배송 중이 아닌경우&nbsp; 회원 탈퇴를 처리합니다.&nbsp;<br>2. 회원이 다음에 해당하는 경우, “고로켓고”는 회원자격을 즉시 제한 및 정지시킬 수 있습니다.&nbsp;<br>가. 가입 신청 시에 허위 내용을 등록한 경우&nbsp;<br>나. “고로켓고”을 이용하면서 “고로켓고” 이용에 관련하여 회원이 부담하는 채무를 기일에 지급하지 않는 경우&nbsp;<br>다. “고로켓고”을 이용하여 법령 또는 이 약관이 금지하거나 상식적인 기준에 반하는 행위를 하는 경우<br>라. 욕설, 음해, 비방,허위사실 공표, 업무방해, 광고행위 등 “고로켓고”의 목적에 반하는 행위를 하는 경우<br>3. “고로켓고”가 회원 자격을 제한/정지시킨 후, 동일한 행위가 2회 이상 반복되거나 14일 이내에 그 사유가 시정되지 아니하는 경우 “고로켓고”는 회원자격을 상실시킬 수 있습니다.&nbsp;<br>4. “고로켓고”가 회원자격을 상실시키는 경우에는 회원 등록을 말소합니다. 이 경우 회원에게 이를 통지하고, 회원 등록 말소 전에 최소한 15일 이상의 기간을 정하여 소명할 기회를 부여합니다.<br>&nbsp;<br>&nbsp;<br>제5조: 회원 개인정보 보호<br>&nbsp;<br>1. “고로켓고”는 회원의 개인정보를 수집하는 때에는 반드시 회원의 동의를 받는다.&nbsp;<br>2. “고로켓고”는 개인정보 수집을 위해 회원의 동의를 얻고자 하는 경우에는 미리 다음 각 호의 사항을 회원에게 고지한다.<br>가. 개인정보 관리 책임자의 성명, 소속 부서, 직위 및 전화번호 기타 연락처 <br>나. 개인정보의 수집 목적 및 이용목적&nbsp;<br>다. 개인정보를 제3자에게 제공하는 경우, 제공받는 자, 제공 목적 및 제공할 정보의 내용&nbsp;<br>라. 정보통신망 이용 촉진 및 정보보호 등에 관한 법률의 제30조 제1항, 제2항 및 제31조 제2항의 규정에 의한 이용자 및 법정대리인의 권한 및 그 행사방법&nbsp;<br>3. 회원이 제공한 개인정보는 당해 회원의 동의 없이 수집 목적 외의 이용이나 제3자에게 제공할 수 없으며, 이에 대한 책임은 “고로켓고”에 있습니다. 다만, 다음의 경우에는 예외로 한다.&nbsp;<br>가. 배송업무상 배송업체에게 배송에 필요한 최소한의 회원의 정보를 제공해야 할 경우 (성명, 개인통관고유번호, 주민등록 번호,사업자등록증, 주소, 전화번호)를 알려주는 경우&nbsp;<br>나. “고로켓고” 서비스 이용계약의 이행을 위해 필요한 경우&nbsp;<br>다. “고로켓고” 서비스의 제공에 따른 요금 정산을 위해 필요한 경우&nbsp;<br>라. 통계 작성, 연구 또는 시장조사를 위해 필요한 경우로서 특정 개인을 식별할 수 없는 형태로 제공하는 경우&nbsp;<br>4. 회원은 “고로켓고”에 제공한 개인정보에 대한 열람을 요구할 수 있으며, 자신의 개인정보에 오류가 있는 경우에는 그 정정을 요구할 수 있으며 “고로켓고”는 이에 대해 지체 없이 필요한 조치를 취할 의무를 집니다. <br>회원이 오류의 정정을 요구한 경우에는 “고로켓고”는 그 오류를 정정할 때까지 당해 개인정보를 이용하지 않는다.&nbsp;<br>5. 회원은 원하는 경우 제1항의 동의를 철회할 수 있으며 동의를 철회한 경우에 “고로켓고”는 수집된 회원정보를 파기하는 등 지체 없이 필요한 조치를 취할 의무를 진다.&nbsp;<br>6. 등록된 개인정보를 철회하고자 하는 회원은 '제8조 회원 탈퇴 규정'에 따라 처리한다.&nbsp;<br>7. “고로켓고” 회원으로부터 동의의 철회, 개인정보의 열람 또는 정정의 요구를 받은 경우에는 필요한 조치를 취할 의무를 진다. <br>8. “고로켓고”로부터 개인정보를 제공받은 제3자는 개인정보의 수집 목적 또는 제공받은 목적을 달성한 때에는 개인정보를 지체없이 파기합니다. 단, 상법 등에 의해 기록 보존이 요구되는 경우는 예외로 한다.<br><br><br>제6조: 회원의 의무<br><br>1. 회원은 다음 각 호의 행위를 하여서는 안 된다.&nbsp;<br>가. 회원가입 또는 회원정보 변경 시 허위 내용의 등록 및 타 회원의 정보 도용행위&nbsp;<br>나. “고로켓고”에 게시된 정보의 훼손&nbsp;<br>다. “고로켓고”이 정한 정보 이외의 정보(컴퓨터 프로그램 등)의 송신 또는 게시&nbsp;<br>라. “고로켓고”와 기타 제3자의 저작권 등 지적재산권에 대한 침해&nbsp;<br>마. “고로켓고”와 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위와 허위사실,외설 또는 폭력적인 메시지, 화상, 음성, 음해성 게시물 등 기타 미풍양속에 반하는 정보나 <br>“고로켓고”의 목적에 맞지 않는 게시글, 업무방해,비방,허위사실 등을 “고로켓고”에 공개 또는 게시하는 행위 (단, 이 경우 “고로켓고”는 임의적으로 게시물을 삭제할 수 있습니다)&nbsp;<br>2. 회원은 제1항의 각호의 의무를 위반하여 발생한 손해에 대해 민사/형사상의 배상 책임을 가진다.<br>3. 회원이 “고로켓고”의 물류센터 주소를 사용하여 물품을 구매하여 물류센터 주소에 물품이 도착하면 “고로켓고”는 회원에게 국제 운송료의 서비스 요금 결제를 요청하고 <br>회원은 해당 금액을 30일 이내에 결제하여야 합니다. 서비스 이용요금이 결제되지 않을 경우 해당 물품은 회원에게로 배송되지 않습니다.<br>4. 회원이 구매한 물품이 “고로켓고”의 물류센터 주소에 도착 후&nbsp; 30일 경과 이후부터&nbsp; 90일까지 보관비가 청구되며, 보관 30일 이후 에&nbsp; 발생하는 물품의 도난, 훼손, 멸실 등에<br>대하여 “고로켓고”는 책임을 지지 아니하며, 노데이터 상품의 경우 30일 이후에는 임의대로 처분하여 보관료로 충당할 수 있습니다. 단,사업자 회원의경우 90일까지 보관비가 면제되며 90일 이후에는 임의처분됩니다.<br>5. 회원은 물품을 구매한 후 “고로켓고” 현지주소에 도착 전까지 배송 신청서 작성 및 트래킹 번호 입력 을 등록해야 할 의무가 있습니다. 이를 이행하지 않아 물류센터에서 확인할 수 없는 물품이 도착한 경우(노데이터), “고로켓고”는 최대 30일까지 해당 물품을 보관합니다.<br>6. 회원은 해당 국가 관련 법의 위배되는 행위로 발생하는 모든 책임은 회원 본인에게 있습니다.<br>&nbsp;<br>&nbsp;<br>제7조: 서비스 중단<br>&nbsp;<br>1. “고로켓고”는 컴퓨터 등 정보통신 설비의 보수 점검,교체 및 고장, 통신의 두절과 천재지변 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있다.&nbsp;<br>2. 사업 종목의 전환, 사업의 포기, 업체 간의 통합 등의 이유로 서비스를 제공할 수 없게 되는 경우에는 “고로켓고”는 회원에게 통지하고 서비스의 제공을 중단할 수 있다.<br>&nbsp;<br>&nbsp;<br>제8조: 회원 통지<br>&nbsp;<br>1. “고로켓고”가 회원에게 통지하는 경우, 회원이 “고로켓고”에 회원가입 시 등록한 핸드폰 번호/ 전자우편 /쪽지/카카오톡/문자/홈페이지내 통합메세지함 등으로 할 수 있다.&nbsp;<br>2. “고로켓고”는 불특정 다수 회원에 대한 통지의 경우 1주일 이상 “고로켓고” 공지사항에 게시함으로서 개별 통지에 갈음할 수 있습니다. 다만, 회원 본인의 거래와 관련하여 중대한 영향을 미치는 사항에 대하여는 개별통지 한다.<br>3."고로켓고"의 통지를 확인하지 아니하여 발생한 회원의 모든 손해에 대해서 "고로켓고"의 책임은 없습니다.<br>&nbsp;<br>&nbsp;<br>제9조: 서비스 신청 변경 / 취소&nbsp;<br>&nbsp;<br>1. 구매대행 계약이 체결된 이후에는 서비스의 변경이나 취소가 원칙적으로 불가능하지만 “고로켓고”가 인정하는 사유로 인한 취소나 변경은 각 해외 인터넷 사이트의 정책에 준거한 취소에 <br>필요한 소요비용 및 손해/손실과 관련된 비용과 수수료는 회원이 지불해야 한다.&nbsp;<br>2. 회원은 서비스 신청 상품 현지 물류센터 도착 전에 해당 신청의 배송지와 배송수단을 변경할 수 있다.&nbsp;<br>3. 회원이 구매하고자 하는 물품이 “고로켓고”가 정하는 금지 취급 물품에 해당하는 경우, “고로켓고”는 해당 물품에 대한 구매 및 배송 등 에 관한 계약 일체를 해지할 수 있다.<br>4. 국제 운송 서비스가 시작된 이후에는 계약일체의 변경이나 취소는 할 수 없다.<br>5. 회원 은 서비스 신청 전에 "고로켓고"명시된 제반 규정, 안내 및 공지,서비스 내용과 비용을 충분히 확인한 후 서비스 신청하여야 한다<br>6. “고로켓고”는 재화 또는 용역의 기술적 사양의 변경 등의 경우에는 장차 체결되는 계약에 의해 제공할 재화 또는 용역의 내용을 변경할 수 있다. 이 경우에는 변경된 재화 또는 용역의 내용 및 <br>제공 일자를 명시하여 현재의 재화 또는 용역의 내용을 게시한 곳에 즉시 공지한다. “고로켓고”가 제공하는 이용자와 계약을 체결한 서비스의 내용을 재화&nbsp; 등의 품절, 가격의 변경 또는 기술적 사양의<br>변경 등의 사유로 변경할 경우에는 그 사유를 이용자에게 공지한다.<br>&nbsp;<br>&nbsp;<br>제10조: 환급 및 추가비용<br>&nbsp;<br>1. “고로켓고”는 구매대행 거래에서 품절/반품/환불 등의 환급사유가 발생할 시, 결제한 비용을 환급한다. 단, 이미 해외 사이트에 결제처리가 된 금액에 대해서는 해외&nbsp; 사이트로부터 환급을 받은 후 환불을 진행한다.&nbsp;<br>2. “고로켓고”는 해외 인터넷 사이트의 가격변동으로 인한 구매대행 거래 대금이 결제금액을 초과하거나 부족한 경우, 초과 금액은 회원에게 청구하며, 남은 금액은 계좌이체 혹은 예치금으로 대체한다.<br>&nbsp;<br>&nbsp;<br>제11조: 입고/검수/포장/배송/통관<br>&nbsp;<br>1. 회원의 구매 상품이 "고로켓고"의 현지 센터 도착 후 입고/검수 1일&nbsp; 포장/발송 1일의 평균 작업시간이 소요되며 작업시간은 천재지변, 불가항력 상황 과 부가 작업,작업 난이도 그리고 "고로켓고" 센터의 작업량의 따라 변동될 수 있습니다.<br>2. 회원께서 작성하신 신청서의 검수기준은 도착 사진을 기준으로 하며 회원님께서 이상 유무를 직접 확인하셔야 합니다.<br>3. 회원께서 작성하신 신청서의 포장기준은 직접 선택하신 포장 옵션에 따릅니다.<br>4. 회원께서 작성하신 신청서의 배송 기준은 입고,검수,포장,결제 완료후&nbsp; 별도 협의되지 않는 경우 가장빠른 선적편으로 진행합니다.<br>5. 회원께서 작성하신 신청서의 배송 요청을 하신 경우 입고,검수,포장 의 이상 유무를 직접 확인한것으로 간주되며 이는 보상 대상이 아닙니다.파손 위험상품의 포장 보완이 되어있지 않을 경우 이는 보상 대상이 아닙니다<br>6. 회원께서 작성하신 신청서의 배송기간은 고로켓고의 발송 이후 선적국세관/도착국세관/항공/해운사/국내택배사/천재지변/불가항력등의 상황에 따라 변동될 수 있으며 이는 보상 대상이 아닙니다.<br>&nbsp;<br>제12조: 반품 및 교환, 파손, 분실<br>&nbsp;<br>1. 회원은 재화 등을 배송받은 경우에 다음 각호에 해당하는 경우에 반품 및 교환할 수 있다.&nbsp;<br>가. 판매자가 반품 및 교환을 명시했거나, 반품 및 교환을 수락한 경우&nbsp;<br>나. 배송대행, 구매대행등 해당 판매자의 거래 약관상 반품 및 교환이 가능한 경우&nbsp;<br>2. “고로켓고” 1항에 해당하는 경우, 규정된 반품 및 교환 조건에 따라, 반품 및 교환을 처리해 주어야 하며, 이 경우 한국에서 중국 또는 해당 배송 국가로의 국제 배송비 및 반품 처리 시 소요되는 <br>경비와 반품 처리에 따른 수수료는 회원이 부담한다.&nbsp;<br>3. 고객의 단순 변심/사이즈 실수/색상 실수의 경우 한국에서 해외 배송국가로 배송되는 국제 배송비 및 반품처리시 소요되는 모든 경비와 반품 처리에 따르는 재반 경비(수수료포함)는 구매 회원이 부담한다.<br>4. 구매대행/배송대행 시 원 판매자로부터의 하자 품(파손/결실)/잘못된 상품의 오배송(사이즈/색상/상품 자체의 오류) 등을 도착 사진으로 직접확인하신후 배송신청을 하신 경우 이로 인한 반송에 드는 모든 경비는 회원이 부담한다.&nbsp;<br>5. 구매대행시&nbsp; “고로켓고”의 귀책사유가 없는 경우 한국에서 해외 배송지까지 국제 배송비, 기타 국내 배송비 등 반송에 소요되는 제반 경비 및 한국으로 재발송 시에 국제 배송비는 회원이 부담한다. <br>6. 항공운송/해운운송/국내 택배/해당국 세관의 검사 후 재포장 오류/국내화물 운송사 등의 배송 과정에서 발생한 파손/손괴/결실은 회원이 해당기관에 직접 보상을 신청/의뢰해야 한다.&nbsp;<br>7. 파손 위험성이 있는 상품의 국제/국내 배송에서 발생하는 파손/손괴/결실 등에 대해서는 “고로켓고”가 아무런 책임을 지지 않으며, 파손 위험성이 있는 물품은 주문&nbsp; 전 “고로켓고”과 상의하거나 <br>국제 배송과 국내 배송 중에서 발생할 수 있는 파손/손괴/결실 등에 대한 위험을 스스로 책임지지 않는다면 주문과 서비스 의뢰를 하지 말아야 한다.&nbsp;<br>8. 국제 배송/국내 배송에 과정의 파손/손괴/결실에 대한 보험은 “고로켓고”에 개별 문의 해야 하며 보험금액은 구입 품목의 가격에 따라 “고로켓고”에서 결정하거나 해당 배송 기관에 문의해야 한다.&nbsp;<br>&nbsp;<br>&nbsp;<br>제13조: 재화 인수, 배송, 보관<br>&nbsp;<br>1. 구매대행 시 구매물품의 대금 지급대행 및 인수와 관련하여 안전한 대금 지급 방법을 사용하여야 하며, 만일 “고로켓고”의 과실로 인한 대금 지불상 문제가 발생하였을 경우에는 “고로켓고”가 책임을 진다. <br>다만, 회원이 “고로켓고”의 인수 및 대금 지급 방법을 거부하였을 시, 그와 관련하여 사기 등의 사고가 발생하는 경우 일체의 보상을 하지 않고, 그와 관련하여 사기 등의 사고가 발생하였을 경우 일체의 보상을 하지 않는다.&nbsp;<br>2. 배송대행 시 원 판매자로부터의 잘못된 상품 배송이나 하자/파손/손괴/누락/결실 상품에 대해서는 일체의 책임을 지지 않으며, 교환이나 환불에 필요한 재 비용과 수수료는 회원이 부담하여야 한다.&nbsp;<br>3. “고로켓고”는 원 상품의 손상을 방지하기 위해서 원칙적으로 도착한 원 포장상태 그대로 배송을 한다. 단지, 회원의 요청이 있을 경우나 재포장이 필요한 상태로 상품이 도착했을 경우(망가지거나 훼손된 포장 등) 재포장 서비스를 하게 되고 재포장 시(혹은 재포장 후) 발생할 수 있는 파손/손괴/결실 등에 대해서는 일체 책임을 지지 않는다. 재포장은 회원의 요청이나 국제 배송에 적합한 포장을 위한 고객 서비스이지만 “고로켓고”의 특성상 본연 의무가 아님을 명시한다.<br>4. 국제 운송료 결제가 완료된 물품에 대해서는 당일 업무시간 또는 결제 시간이 정상업무시간 이후일 경우 익일 배송할 수 있도록 포장 등 기타의 필요한 조치를 취한다.<br>5. 4항과 관련하여 “고로켓고”는 이용자의 요청이 있는 경우, 이용자의 배송 승인 지연의 경우, 경영상의 부득이한 사유, 천재지변 등으로 배송 시기를 연장할 수 있습니다.&nbsp;<br>6. 회원이&nbsp; 구매 신청, 배송신청,부가 서비스 신청 후 지정한 시간 이내에 “고로켓고” 서비스 요금을 결제하지 않은 경우, “고로켓고”는 해당 상품을 임의로 처리할 수 있으며, 회원에게 물품의 보관 및 처분과 관련한 비용 등을 청구한다.&nbsp;<br>7. 인수물품의 보관.&nbsp;<br>가. “고로켓고”의 최대 보관기관은 90일이며, 이후 물품의 손실에 대해서 어떠한 책임도 지지 않는다. 30일이 지난 물품은 규정에 따라 창고보관료와 일일 수수료가 청구되며, 90일이 지난 상품은 폐기처분 됨을 규정으로 한다.&nbsp;<br>나. “고로켓고”는 인수물품이 “고로켓고”의 배송 기준을 초과하거나 보관기간(30일)을 초과하는 물품에 대해서는 별도의 보관비나 재포장 비용을 청구할 수 있다. 단, 물품보관에 대해 “고로켓고”가 인정하는 이유가 있는 경우 <br>보관료를 면제할 수 있다. 단, 어떠한 경우에도 90일을 초과할 수 없다.&nbsp;<br>8. 회사는 물품의 포장 개선을 통한 안전하고 신속한 배송을 위해 회원의 사전동의 없이 물품을 재포장 할 수 있습니다.&nbsp;<br>&nbsp;<br><br>제14조: 책임의 한계 / 범위<br>&nbsp;&nbsp;<br>1. “고로켓고”는 서비스 제공과 관련하여 귀책사유로 회원에게 발생한 손해에 대하여 회원이 물품을 구입할 당시의 물품 가격과 재 비용범위 내에서 회원에게 배상책임을 부담한다.&nbsp;<br>가. “고로켓고”의 실수로 잘못된 사이즈/색상상품을 구매하여 구매대행 신청한 상품과 다를 경우&nbsp;<br>나. “고로켓고”의 주소지 오기재로 상품의 손실이 발생했을 경우&nbsp;<br>2. 배송대행 요청 시 물품에 대한 검수는 의무가 아니고 회원의 요청에 의한 서비스이며, “고로켓고”는 실제 판매상이 아니기 때문에 상품의 품질/재질/구성/재조상세정보에 대해서는 아무런 책임을 지지 않는다.&nbsp;<br>3. “고로켓고”는 어떠한 경우에도 구입 상품 자체에 대한 동작확인이나 수량, 진품 여부의 보증, 상품 품질의 보증을 하지 않는다.&nbsp;<br>4. 회원의 물품이 보관 기간을 초과하였을 경우에 천재지변 /불가항력 등의 부득이한 사유로 발생하는 물품의 파손 및 손실은 책임지지 않는다.&nbsp;<br>5. 개인회원이 자가 사용 목적이 아닌 국내 판매 등을 위해 수입하는 행위로 인해 법적 규제가 발생한 경우 책임지지 않는다.&nbsp;<br>6. 국내 수입/반입 규제 품목에 대한 세관의 반송이나 폐기처분 방침에 대해서 책임을 지지 않는다.&nbsp;<br>7. 판매자의 일방적인 거래 취소나 변심은 “고로켓고”가 책임지지 않는다.<br>8. 천재지변/원 판매자의 배송지연 등은 “고로켓고”에서 책임지지 않는다.<br>9. 회원이 직접 주문/결제하는 배송대행의 경우, 원 판매자의 오배송/사이즈 실수/수량실수/색상실수/상품의 품질/단순변심/파손/손괴/결실 /주문상의 오류/유실등 배송 중 야기되는 어떠한 문제나 사고에 대해서는 일체의 책임지지 않는다.<br>10. 국제 배송/국내 배송/세관검사 후 포장오류/국내화물운송사 등으로 인한 파손/손괴/결실 등은 해당기관(운송사,항공사,해운사,국내 택배사, 세관,화물 운송사등)에 회원이 직접 문의해야 하며 “고로켓고”는 아무런 책임을 지지 않는다.&nbsp;<br>11. “고로켓고”는, 한국으로 국제 배송 서비스를 제공하지 않는 사이트 등에서의 구입에 필요한 중국 내 배송 주소지를 제공하고, 국제 배송 서비스를 제공하지만, 국제배송비가 지나치게 비싼 경우 항공사/해운사/택배사와의 저렴한 계약 체결을 대행하는 역할만 담당하는 것이 주 의무이며, 해외 사이트에서 구매후 배송되어온 포장상태(Original Package) 그대로 국제 배송을 하게 되고, 고객의 요청이 있을 시나 부득이한 경우(박스 외포장 파손시)에만 국제 배송의 규정에 맞게 재포장 작업을 거치며, 중국내 배송/국제 배송/국내 배송중 발생하는 어떠한 사고에 대해서도 일체 책임을 지지 않는다. (* 단, 발송 상품에 대한 사전 보험계약이 성립된 경우는 제외)<br>12. 고로켓고의 구매/입고/검수/포장/보관/국제 배송 등 고로켓고 고유 관련업무는 사이트에 안내된 내용을 기준으로 업무 처리 진행되며,&nbsp; 사이트에 안내된 내용으로 업무 진행 처리하였을 경우 보상 요구에 대한 고로켓고의 책임은 없습니다.<br>13. "고로켓고"은 회원의 관련 해당국가의 법 위반으로 발생되는 손해에 대하여 일체 책임지지 않는다.<br>&nbsp;<br>&nbsp;<br>제15조: 서비스 신청&nbsp;<br>&nbsp;<br>“고로켓고” 이용자는 “고로켓고”상에서 다음 또는 이와 유사한 방법으로 정확한 정보를 제공한 다음 서비스를 신청한다.&nbsp;<br>[배송대행]<br>1. 회원이 직접 주문/결제한 판매자 및 해외 인터넷 쇼핑 사이트 명.<br>2. 주문/결제한 상품(들)의 가격과 상세내역.<br>3. 주문자와 수령자의 정확한 영문 이름.<br>4. 국내 상품 수취 주소/수취인 성함/연락처(전화번호)/주민등록번호.( 개인통관번호 또는 사업자등록번호)<br>[구매대행]<br>1. 주문/결제 의뢰할 상품(들)에 대한 정확한 개별 상품 주소.(URL)<br>2. 수량/색상/사이즈 등 필요한 선택사항.&nbsp;<br>3. 국내 상품 수취 주소/수취인 성함/연락처(전화번호)/주민등록번호.(개인통관 부호 또는 사업자등록증)<br>4. 주문/결제에 필요한 거래 견적 금액의 결제자 이름.<br>[LCL/FCL 화물운송]<br>1. 운송할 화물(상품)들의 대한 정확한 정보 입력.(구매처/가격/수량/색상/사이즈등)<br>2. 국내 상품 수취 주소/수취인 상호/이메일/성함/연락처/사업자등록증.<br>&nbsp;<br>&nbsp;<br>제16조: 계약의 성립&nbsp;<br>1. “고로켓고”는 서비스 신청에 대하여 다음 각호에 해당하면 서비스를 승낙하지 않을 수 있다. 다만, 미성년자와 계약을 체결하는 경우에는 법정대리인의 동의를 얻지 못하면 미성년자 본인<br>또는 법정대리인이 계약을 취소할 수 있다는 내용을 고지한다. <br>가. 신청 내용에 허위, 기재누락, 오기가 있는 경우&nbsp;<br>나. 미성년자가 담배, 주류 등 청소년보호법에서 금지하는 재화 및 용역을 구매하는 경우&nbsp;<br>다. 기타 서비스 신청에 승낙하는 것이 “고로켓고” 기술상/특성상 현저히 지장이 있다고 판단하는 경우<br>라. “고로켓고”의 승낙이 주문 접수 덧글/쪽지/선구매/구두/대화/기타 관습적 형태로 이용자에게 도달한 시점에 계약이 성립한 것으로 본다.&nbsp;<br>마. 배송대행 신청 시 배송대행 신청을 접수한 시점부터 계약은 성립한 것으로 본다<br>바. 구매대행 신청 시 필요한 서비스 대금을 지불한 시점부터 계약은 성립한 것으로 본다.<br>&nbsp;<br><br>제17조: 분쟁해결<br>&nbsp;<br>1. “고로켓고”는 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해 보상에 최선을 다한다.<br>2. “고로켓고”는 이용자로부터 제출되는 불만사항 및 의견은 우선적으로 처리하도록 최선을 다한다.&nbsp;<br>&nbsp;<br>&nbsp;<br>제18조: 취급 제한 재화<br>1. “고로켓고”는 아래의 경우 회원에게 통보 후 물품을 원 발송자에게로 반송할 수 있으며, 회원의 귀책사유로 인해 회원의 소재가 불명확한 경우에는 특정 물품을 원 발송인에게 반송할 수 있다. 이때 발생한 소요비용은 회원이 부담한다.&nbsp;<br>가. 동물, 금,은 등 보석류, 화폐, 의약품, 무기류, 인체의 일부, 포르노그래피, 정밀금속, 석재류, 냉동 또는 냉장을 요하는 물품 및 폭발물, 가연성 위험물 기타 등등&nbsp;<br>나. 수입, 수출 불가 / 해상 및 항공 선적 운송 불가 품목일 경우&nbsp;<br>다. 배송/구매 신청서 및 송장(Invoice) 내용 부실기재, 포장 불량 등으로 본 약관에 따른 서비스를 제공하기에 적절하지 않다고 “고로켓고”가 판단한 경우 &nbsp;<br>라. 기타 관련 법령에 의하여 수출입이 제한되는 물품일 경우.<br>마. 소액면세를 적용받을 수 없는 물품을 반복 또는 분할하여 수입하거나 수입을 대행함으로써 면세 적용받기 위해 분할 배송을 강요하는 경우<br>2. 1항 중 경영상의 사유로 서비스를 제공할 수 없다고 “고로켓고”가 판단한 재화 등은 회원과의 별도 계약을 통해 서비스를 제공하거나, 서비스 제공을 거부할 수 있다.<br>3. 1항에 해당하는 재화 등의 거래 취소에 따른 소요비용은 회원이 부담하여야 한다.<br>&nbsp;<br>&nbsp;<br>제19조(재판권 및 준거법)<br>1. 회사와 이용자 간에 발생한 전자상거래 분쟁에 관한 소송은 제소 당시 회사의 주소를 관할하는 법원의 전속관할로 합니다.&nbsp;<br>2. 회사와 이용자 간에 제기된 소송에는 대한민국 법을 적용합니다.<br>&nbsp;<br><br></p>         
					</div>      
				</div>
				<el-radio-group style="display: flex;justify-content: flex-end;margin:20px 20px 20px 0;" v-model="ruleForm.service">
				  <el-radio label="동의안함"></el-radio>
				  <el-radio label="동의함"></el-radio>
				</el-radio-group>
				 <!-- 个人信息的收集和使用 -->
				<h4>개인정보 수집 및 이용</h4>
				<div class="agreement-box">
					<div class="height-fixed-box">
						<p>개인정보 수집 및 이용에 관한 처리 방침<br><br>㈜에스오씨피 (이하 "회사"라 함)는 아래와 같이 개인정보취급방침을 정하여 고객님의 개인정보를 중요시하며, "정보통신망 이용 촉진 및 정보보호"에 관한 법률을 준수하고 있습니다.<br>본 개인정보취급방침은 회사가 운영하는 본 웹사이트(https://www.goroketgo.com)에서 이용자의 정보를 수집 및 활용하는 방법과 범위를 알려 드리기 위한 내용을 담고 있습니다.<br>본 웹사이트를 이용하시거나 개인정보를 제출하시기 전에 아래 내용을 먼저 확인해 보시길 바랍니다.<br>&nbsp;<br>수집하는 개인 정보의 항목 및 수집 방법<br>&nbsp;<br>1. 회사는 회원가입, 원활한 고객상담, 각종 서비스의 제공을 위해 최초 회원가입 시 이용자의 동의하에 아래와 같은 정보를 필수 항목으로 수집하고 있습니다.&nbsp;<br>1) 개인 회원<br>- 성명(국문, 영문), 아이디, 비밀번호, 이메일, 주소, 전화번호, 휴대폰 번호, 생년월일, 성별<br>2) 사업자 회원<br>- 이름(국문,영문), 상호(개인 또는 법인명 국문, 영문), 아이디, 비밀번호, 이메일, 사업장 소재지(국적 및 주소), 판매 몰, 운영 웹사이트 URL, 전화번호, 휴대폰 번호, 생년월일(법인은 설립일), 성별<br>&nbsp;<br>2. 서비스 이용과정이나 사업 처리 과정에서 아래와 같은 정보들이 자동으로 생성되어 수집될 수 있습니다.<br>&nbsp;- 쿠키, 서비스 이용 기록, 불량 이용 기록<br>&nbsp;<br>3. 유료 서비스 이용 시 아래와 같은 결제 정보들이 수집될 수 있습니다.<br>&nbsp;- 신용카드 결제 시 : 카드사명, 카드 소유자명, 카드번호, 유효기간 등<br>&nbsp;<br>&nbsp;4. 개인정보 수집 방법<br>회사는 다음과 같은 방법으로 개인정보를 수집합니다.<br>- 홈페이지, 전화, 상담 게시판, 이메일, 이벤트 응모, 배송 요청 등.<br>- 생성 정보 수집 도구를 통한 방법, 회사의 협력회사로부터의 제공&nbsp;<br>&nbsp;<br>&nbsp;<br>▶개인정보의 수집 목적&nbsp;<br>&nbsp;<br>1. 서비스 제공에 관한 계약 이행 및 요금정산<br>물품 배송, 본인인증, 구매 및 요금 결제, 요금 추심, 컨텐츠 제공, 맞춤 서비스 제공 등.<br>&nbsp;<br>2. 회원관리<br>회원 개인 식별, 가입 의사 확인, 회원 서비스 이용, 불량 회원 사용 방지, 비인가 사용 방지, 가입 횟수 제한, 분쟁 조정을&nbsp;<br>위한 기록 보존, 민원처리, 관세 등 각종 세금정보 및 통관 관련 정보 고지 등.<br>&nbsp;<br>3. 마케팅ㆍ광고ㆍ통계에의 활용 및 신규 서비스 개발<br>통계학적 특성에 따른 서비스 제공 및 광고 게재, 이벤트 및 광고성 정보 제공 및 참여기 회 제공, 접속빈도 파악,&nbsp;<br>회원의 서비스 이용에 각종 통계 조사 및 맞춤형 서비스 등 신규 서비스 개발.<br>&nbsp;<br>▶개인정보의 보유기간<br><br>개인정보는 서비스를 이용하는 동안 원활한 서비스 이용을 위해 계속 보유하나 회원 탈퇴 신청이나 서비스 중단 등의 상황이 발생할 경우 해당 정보를 <br>바로 파기하거나 외부 공개를 막습니다. 단 다음의 경우에는 명시한 기간 동안 보존합니다.<br><br>* 보존 항목: ID, 생년월일, 이메일 주소<br>* 보존 이유: 서비스 이용의 혼선 방지, 불법적 사용자에 대한 관련 기관 수사협조<br>* 보존 기간: 1년<br><br>또한 관계법령에 정한 기간 동안 회원정보를 보관할 수 있습니다.<br><br>* 보존 항목: 서비스 이용 기록, 방문 기록, IP 정보<br>* 보존 이유: 통신비밀 보호법<br>* 보존 기간: 3개월<br>&nbsp;<br>&nbsp;<br>개인정보 수집의 동의 회사는 귀하의 개인정보 수집에 대한 동의를 받고 있습니다. 귀하의 개인정보 수집과 관련하여 본 웹사이트의 개인정보취급방침 또는 <br>이용 약관의 내용에 대한 『동의』버튼 또는 『동의 안 함』 버튼을 클릭할 수 있는 절차를 마련하고 있으며, <br>귀하가 『동의』버튼을 클릭하면 개인정보 수집에 대해 동의한 것으로 봅니다.<br>&nbsp;<br>▶개인정보 자동 수집 장치의 설치, 운영 및 그 거부에 관한 사항<br>회사는 귀하의 정보를 수시로 저장하고 찾아내는 ‘쿠키(cookie)’ 등을 운용합니다. 쿠키란 회사의 웹사이트를<br>운영하는데 이용되는 서버가 귀하의 브라우저에 보내는 아주 작은 텍스트 파일로서 귀하의 컴퓨터 하드디스크에 저장됩니다. <br>회사는 다음과 같은 목적을 위해 쿠키를 사용합니다.<br>&nbsp;<br>▶ 쿠키 등 사용 목적<br>- 회원과 비회원의 접속 빈도나 방문 시간 등을 분석, 이용자의 취향과 관심분야를 파악 및 자취 추적, 각종 이벤트 참여 정도 및 방문 회수 파악 등을 통한 타겟 마케팅 및 개인 맞춤 서비스 제공<br>- 귀하는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 귀하는 웹 브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, <br>아니면 모든 쿠키의 저장을 거부할 수도 있습니다.<br>&nbsp;<br>▶ 쿠키 설정 거부 방법<br>- 예: 쿠키 설정을 거부하는 방법으로는 회원님이 사용하시는 웹 브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, <br>모든 쿠키의 저장을 거부할 수 있습니다.<br>&nbsp;<br>*설정 방법 예(인터넷 익스플로어의 경우): 웹 브라우저 상단의 도구 &gt; 인터넷 옵션 &gt; 개인정보<br>&nbsp;<br>단, 귀하께서 쿠키 설치를 거부하였을 경우 서비스 제공에 어려움이 있을 수 있습니다.<br>&nbsp;<br>&nbsp;<br>[개인정보의 공유 및 제공]<br>&nbsp;<br>회사는 이용자들의 개인정보를 ‘개인정보의 수집 목적’에서 고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이는 동 범위를 초과하여 이용하거나 <br>원칙적으로 이용자의 개인정보를 외부에 공개하지 않습니다. 다만, 이용자들이 사전에 공개에 동의 경우 및 법령의 규정에 의거하거나, <br>수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우는 예외로 합니다.<br>&nbsp;<br>[개인정보의 보호]<br>&nbsp;<br>회사는 이용자의 개인정보의 취급에 있어 분실, 도난, 누출, 변조 또는 훼손이 일어나지 않도록 각종 기술적/관리적 대책을 강구하고 있습니다.<br>다만, 비밀번호 등 주요 개인정보를 이용자 스스로가 관리를 허술하게 하여 분실, 도난, 누출 시켰을 경우 그 책임은 이용자에게 있으므로, 관리에 유의하시기 바랍니다.<br>&nbsp;<br>&nbsp;<br>[개인정보관리 책임자 및 담당자의 연락처]<br>&nbsp;<br>귀하께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보관리 책임자에게 신고하실 수 있습니다.<br>회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.&nbsp;<br>&nbsp;<br>[개인정보 관리책임자]<br>&nbsp;<br>이름 : 정원교<br>전화 : 1566-9090<br>메일 : cs@goroketgo.com<br>&nbsp;</p>
					</div>      
				</div>
				<el-radio-group style="display: flex;justify-content: flex-end;margin:20px 20px 20px 0;" v-model="ruleForm.information">
				  <el-radio label="동의안함"></el-radio>
				  <el-radio label="동의함"></el-radio>
				</el-radio-group>
			
				<h4 class="border-bottom">필수정보 입력</h4>
				

			  <div class="from-main">
				  <!--用户id-->
				 <el-row>
				  <el-col :xs="24" :sm="5">
					<div class="from-title">아이디 <span class="required-addon">(필수)</span></div>
				  </el-col>
				  <el-col :xs="24" :sm="19">
					  <el-form-item  prop="username">
						  <el-input v-model="ruleForm.username" style="width: 300px;" autocomplete="username" name="username"></el-input>
						  <div class="help-block">영문 소문자, 숫자, 밑줄(_)만 가능하며, 4자이상 20자이하로 입력</div>
					  </el-form-item>  
				  </el-col>
				 </el-row>
				 <!--姓名-->
				 <el-row style="padding: 10px 0 20px;">
				  <el-col :xs="24" :sm="5">
				 		<div class="from-title">이름 <span class="required-addon">(필수)</span></div>
				  </el-col>
				  <el-col :xs="24" :sm="19">
					  <el-form-item  prop="nickname">
						<el-input v-model="ruleForm.nickname" style="width: 300px;" autocomplete="name" name="nickname"></el-input>
					  </el-form-item>  
				  </el-col>
				 </el-row>
				 <!--密码-->
				 <el-row>
				  <el-col :xs="24" :sm="5">
				 		<div class="from-title">비밀번호 <span class="required-addon">(필수)</span></div>
				  </el-col>
				  <el-col :xs="24" :sm="19">
					  <el-form-item  prop="password">
						  <el-input v-model="ruleForm.password" type="password" style="width: 300px;" autocomplete="new-password" name="password"></el-input>
						  <div class="help-block">비밀번호는 영문, 숫자, 특수문자를 포함하여 8자 이상 입력해 주세요.</div>
					  </el-form-item>  
				  </el-col>
				 </el-row>
				 <!--验证密码-->
				 <el-row>
				  <el-col :xs="24" :sm="5">
				 		<div class="from-title">확인용 비밀번호 <span class="required-addon">(필수)</span></div>
				  </el-col>
				  <el-col :xs="24" :sm="19">
					  <el-form-item  prop="repassword">
						  <el-input v-model="ruleForm.repassword" type="password" style="width: 300px;" autocomplete="new-password"></el-input>
					  </el-form-item>  
				  </el-col>
				 </el-row>
				 <!--移动电话 手机-->
				 <el-row>
				  <el-col :xs="24" :sm="5">
				 		<div class="from-title">모바일 <span class="required-addon">(필수)</span></div>
				  </el-col>
				  <el-col :xs="24" :sm="19">
					  <el-row>
						  <el-col :xs="6" :sm="4">
							  <el-form-item  prop="areacode">
								  <el-select style="width: 80px;" v-model="ruleForm.areacode" value-key="010" placeholder="请选择">
									<el-option v-for="item in areacode_options" :label="item.label" :value="item.value" :key="item.value"></el-option>
								  </el-select>
							  </el-form-item> 
						  </el-col>
						  <el-col :xs="18" :sm="20">
							 <el-form-item  prop="mobile">
							 	<el-input v-model="ruleForm.mobile" type="text" style="width: 180px;" class="phone-input"></el-input>
							 </el-form-item>   
						  </el-col>
					  </el-row>
				  </el-col>
				 </el-row>
				 <!--EMAIL-->
				  <el-row>
				   <el-col :xs="24" :sm="5">
				  		<div class="from-title">이메일 <span class="required-addon">(필수)</span></div>
				   </el-col>
				   <el-col :xs="24" :sm="19">
					  <el-form-item  prop="email">
						  <el-input v-model="ruleForm.email" style="width: 300px;" ></el-input>
					  </el-form-item>  
				   </el-col>
				  </el-row>
				  <!--引荐人用户ID-->		  
				  <el-row>
				   <el-col :xs="24" :sm="5">
				  		<div class="from-title">추천인 아이디 </div>
				   </el-col>
				   <el-col :xs="24" :sm="19">
					  <el-form-item  prop="recommend_id">
						  <el-input v-model="ruleForm.recommend_id" style="width: 300px;" ></el-input>
						  <div class="help-block">필수입력은 아니며, 추천인 아이디가 있는 경우에만 입력하면 됩니다.</div>
						  <!-- <div class="referral-benefit-tip">
							  <i class="el-icon-present"></i>
							  추천인 아이디를 입력하시면 첫 배송비 할인 혜택을 받으실 수 있습니다.
						  </div> -->
					  </el-form-item>
				   </el-col>
				  </el-row>
				 
			  </div>
			  
			  <h4 class="border-bottom">추가정보 입력</h4>
			  <div class="from-main">
				  <!--个人清关唯一代码-->
				  <el-row>
				   <el-col :xs="24" :sm="8">
				  		<div class="from-title">개인통관고유부호 <span class="required-addon">(필수)</span></div>
				   </el-col>
				   <el-col :xs="24" :sm="16">
					  <el-form-item  prop="customs_info">
						  <div style="display: flex; align-items: center; flex-wrap: wrap;">
							  <el-input v-model="ruleForm.customs_info" style="width: 300px;" placeholder="P로 시작하는 13자리 입력" @input="val => ruleForm.customs_info = val.toUpperCase()"></el-input>
							  <div class="customs_button" @click="goCustomsinfoUrl('https://unipass.customs.go.kr/csp/persIndex.do')">
								  개인통관고유부호 발급방법 <i class="el-icon-top-right"></i>
							  </div>
						  </div>
						  <div class="help-block">개인통관고유부호는 'P'로 시작하고 총 13자리입니다. (예: P123456789012)</div>
					  </el-form-item>  
				   </el-col>
				  </el-row>
				  <!--性别-->
				  <el-row>
				   <el-col :xs="24" :sm="8">
				  		<div class="from-title">성별 </div>
				   </el-col>
				   <el-col :xs="24" :sm="16">
					  <el-form-item  prop="gender">
							<el-radio-group v-model="ruleForm.gender">
							  <el-radio label="남자" ></el-radio>
							  <el-radio label="여자" ></el-radio>
							</el-radio-group>
					  </el-form-item>  
				   </el-col>
				  </el-row>
				  <!--生日-->
				  <el-row>
				   <el-col :xs="24" :sm="8">
				  		<div class="from-title">생년월일 </div>
				   </el-col>
				   <el-col :xs="24" :sm="16">
					  <el-form-item prop="birthday">
						  <div class="birthday-selects">
							  <el-select v-model="birthYear" placeholder="년도" style="width: 110px;" @change="onBirthdayChange">
								  <el-option v-for="y in yearOptions" :key="y" :label="y + '년'" :value="y"></el-option>
							  </el-select>
							  <el-select v-model="birthMonth" placeholder="월" style="width: 90px; margin-left: 8px;" @change="onBirthdayChange">
								  <el-option v-for="m in monthOptions" :key="m" :label="m + '월'" :value="m"></el-option>
							  </el-select>
							  <el-select v-model="birthDay" placeholder="일" style="width: 90px; margin-left: 8px;" @change="onBirthdayChange">
								  <el-option v-for="d in dayOptions" :key="d" :label="d + '일'" :value="d"></el-option>
							  </el-select>
						  </div>
					  </el-form-item>
				   </el-col>
				  </el-row>
				  <!--地址-->
	<!-- 			  <el-row>
				   <el-col :xs="24" :sm="8">
				  		<div class="from-title">주소 </div>
				   </el-col>
				   <el-col :xs="24" :sm="16">
				  		
				   </el-col>
				  </el-row> -->
			  </div>
			  
			  <el-checkbox class="biz-checkbox-large" style="display: flex;align-items: center; margin:20px 20px 20px 0;"  v-model="ruleForm.business">사업자등록증 추가</el-checkbox>
			  <div class="extend-biz" v-if="ruleForm.business">
				<!--  <el-row>
					  <el-col :xs="24" :sm="12"></el-col>
					  <el-col :xs="24" :sm="12"></el-col>
				  </el-row> -->
				  <h4 class="border-bottom">사업자정보 입력</h4>
				  <span v-if="!isMobile">
					  *사업자회원의 경우 구매대행, 수입과 관련없는 업태/종목일 경우<br>
					  사업자회원으로 가입이 제한되며 일반회원으로만 가입 가능합니다.
				  </span>
				  <div v-else style="color: var(--main-color);font-size: 13px; padding:0 10px;">
					  *사업자회원의 경우 구매대행, 수입과 관련없는 업태/종목일 경우<br>
					  사업자회원으로 가입이 제한되며 일반회원으로만 가입 가능합니다.
				  </div>
				  <!--企业名称-->
				  <el-row style="padding: 10px 0 0;">
				   <el-col :xs="24" :sm="8">
				  		<div class="from-title">상호명 <span class="required-addon">(필수)</span></div>
				   </el-col>
				   <el-col :xs="24" :sm="16">
					  <el-form-item  prop="biz_company">
						<el-input v-model="ruleForm.biz_company" style="width: 300px;" ></el-input>
					  </el-form-item>  
				   </el-col>
				  </el-row>
				  <!--商业登记号码-->
				  <el-row >
				   <el-col :xs="24" :sm="8">
				  		<div class="from-title">사업자등록번호 <span class="required-addon">(필수)</span></div>
				   </el-col>
				   <el-col :xs="24" :sm="16">
					  <el-form-item  prop="biz_number">
						<el-input v-model="ruleForm.biz_number" style="width: 300px;" @input="filterBizNumber" placeholder="'-' 없이 숫자만 입력"></el-input>
						<div class="help-block" style="color: #e6a23c;"><i class="el-icon-warning-outline"></i> '-' 없이 숫자만 입력해 주세요</div>
					  </el-form-item>  
				   </el-col>
				  </el-row>
				  <!--代表姓名-->
				  <el-row >
				   <el-col :xs="24" :sm="8">
				  		<div class="from-title">대표자명 <span class="required-addon">(필수)</span></div>
				   </el-col>
				   <el-col :xs="24" :sm="16">
					  <el-form-item  prop="biz_ceo">
						<el-input v-model="ruleForm.biz_ceo" style="width: 300px;" ></el-input>
					  </el-form-item>  
				   </el-col>
				  </el-row>
				  <!--业务联系人 手机-->
				  <el-row>
				   <el-col :xs="24" :sm="8">
				  		<div class="from-title">사업장연락처 </div>
				   </el-col>
				   <el-col :xs="24" :sm="16">
					  <el-row>
						  <el-col :xs="6" :sm="4">
							  <el-form-item  prop="biz_areacode">
								  <el-select style="width: 80px;" v-model="ruleForm.biz_areacode" value-key="010" placeholder="请选择">
									<el-option v-for="item in areacode_options" :label="item.label" :value="item.value" :key="item.value"></el-option>
								  </el-select>
							  </el-form-item> 
						  </el-col>
						  <el-col :xs="18" :sm="20">
							 <el-form-item  prop="biz_tel">
								<el-input v-model="ruleForm.biz_tel" type="text" style="width: 180px;" class="phone-input"></el-input>
							 </el-form-item>   
						  </el-col>
					  </el-row>
				   </el-col>
				  </el-row>
				  <!-- 营业执照 -->
				  <el-row style="padding: 10px 0 20px;">
				   <el-col :xs="24" :sm="8">
				  		<div class="from-title">사업자등록증 <span class="required-addon">(필수)</span></div>
				   </el-col>
				   <el-col :xs="24" :sm="16">
						<el-upload
				
						  :action="update_url+'/common/upload'"
						  :before-upload="beforeAvatarUpload"
						  :on-preview="handlePreview"
						  :on-remove="handleRemove"
						  :before-remove="beforeRemove" 
						  :on-success="handleAvatarSuccess"
						  :on-progress="handleProgress"
						  :on-error="handleAvatarError"
						  :limit="1"
						  :on-exceed="handleExceed"
						  :file-list="fileList"
						  :show-file-list="false">
						  <el-button size="small" type="primary" :loading="isUploading">파일 선택</el-button>
						  <div slot="tip" class="el-upload__tip">jpg/png 파일만 업로드 가능하며, 최대 10MB까지 가능합니다</div>
						</el-upload>
						<!-- 上传进度条 -->
						<el-progress v-if="isUploading" :percentage="uploadPercent" style="width: 300px; margin-top: 10px;"></el-progress>
						<!-- 缩略图展示区域 -->
						<div class="license-thumbnail" v-if="ruleForm.license_url">
							<div class="thumbnail-wrapper">
								<img :src="licenseFullUrl" alt="사업자등록증" @click="handlePreviewImage" />
								<div class="thumbnail-overlay" @click="removeLicense">
									<i class="el-icon-delete"></i>
									<span>삭제</span>
								</div>
							</div>
						</div>
				
				   </el-col>
				  </el-row>
				  
			  </div>
			  

			  <el-form-item style="text-align:center;">
			    <el-button type="primary" native-type="submit">가입하기</el-button>
			    <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
				<el-button @click="onReturn">뒤로</el-button>
			  </el-form-item>
			</el-form>
		
		</div>
		
		
		
	</div>
</template>

<script>
	import request from '@/utils/request';
	import { mapActions } from 'vuex';
	import { safePush } from '@/utils/router';
	import Constants from '@/constants'
	export default {
		data() {
			return {
				ruleForm: {
					update_url:"",
					  service:'동의안함',
					  information:'동의안함',
					  username: '',
					  nickname:'',
					  password:'',
					  mobile:'',
					  areacode:'010',
					  email:'',
					  recommend_id:'',
					  customs_info:'',
					  gender:'남자',
					  birthday:'',
					  
					  business:'',
					  identity:'',
					  biz_company:'',
					  biz_number:'',
					  biz_ceo:'',
					  biz_tel:'',
					  biz_areacode:'010',

					  license_url:'',
					},
					fileList: [],
					isUploading: false,
					uploadPercent: 0,
					birthYear: '',
					birthMonth: '',
					birthDay: '',
					areacode_options: [
						{
							value: '010',
							label: '010'
						},{
							value: '011',
							label: '011'
						},{
							value: '016',
							label: '016'
						},{
							value: '017',
							label: '017'
						},{
							value: '018',
							label: '018'
						},{
							value: '019',
							label: '019'
						}
					],
					rules: {
					  username: [
						{ required: true, message: '사용자 ID를 입력해주세요', trigger: 'blur' },
						{ min: 4, max: 20, message: '길이가 4~20자 사이여야 합니다', trigger: 'blur' }
					  ],
					  nickname: [
						{ required: true, message: '이름을 입력해주세요', trigger: 'blur' }
					  ],
					  password: [
					  	{ required: true, message: '비밀번호를 입력해주세요', trigger: 'blur' },
						{ validator: (rule, value, callback) => {
							const regex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;
							if (value && !regex.test(value)) {
							  callback(new Error('영문, 숫자, 특수문자를 포함하여 8자 이상 입력해 주세요'));
							} else {
							  callback();
							}
						}, trigger: 'blur' }
					  ],
						repassword: [
							{ required: true, message: '비밀번호 확인을 입력해주세요', trigger: 'blur' },
							{ validator: (rule, value, callback) => {
								if (value === '') {
								  callback(new Error('비밀번호를 다시 입력해주세요'));
								} else if (value !== this.ruleForm.password) {
								  callback(new Error('비밀번호가 일치하지 않습니다!'));
								} else {
								  callback();
								}
						  }, trigger: 'blur' }
						],
						mobile:[
							{ required: true, message: '휴대폰 번호를 입력해주세요', trigger: 'blur' }
						],
						email:[
							{ required: true, message: '이메일을 입력해주세요', trigger: 'blur' },
							{ validator: (rule, value, callback) => {
								const regex = /^(?![-+.])(?![-+.]$)(?<![-+.])[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;		
								if (value && !regex.test(value)) {
								  callback(new Error('이메일 형식이 올바르지 않습니다'));
								} else {
								  callback();
								}
							}, trigger: 'blur' }
						],
						customs_info: [
							{ required: true, message: '개인통관고유부호를 입력해주세요', trigger: 'blur' },
							{ validator: (rule, value, callback) => {
								const regex = /^[pP]\d{12}$/;
								if (value && !regex.test(value)) {
									callback(new Error("개인통관고유부호는 'P'로 시작하고 총 13자리여야 합니다"));
								} else {
									callback();
								}
							}, trigger: 'blur' }
						],
						biz_company: [
							{ required: true, message: '상호명을 입력해주세요', trigger: 'blur' }
						],
						biz_number: [
							{ required: true, message: '사업자등록번호를 입력해주세요', trigger: 'blur' }
						],
						biz_ceo: [
							{ required: true, message: '대표자명을 입력해주세요', trigger: 'blur' }
						]
					}
				

			};
		},
		computed: {
		  isMobile() {
			return window.innerWidth <= 768;
		  },
		  yearOptions() {
			const years = [];
			const currentYear = new Date().getFullYear();
			for (let i = currentYear; i >= 1930; i--) {
				years.push(i);
			}
			return years;
		  },
		  monthOptions() {
			return Array.from({ length: 12 }, (_, i) => i + 1);
		  },
		  dayOptions() {
			const year = parseInt(this.birthYear);
			const month = parseInt(this.birthMonth);
			if (!year || !month) return Array.from({ length: 31 }, (_, i) => i + 1);
			const daysInMonth = new Date(year, month, 0).getDate();
			return Array.from({ length: daysInMonth }, (_, i) => i + 1);
		  },
		  licenseFullUrl() {
			if (this.fileList && this.fileList.length > 0) {
				return this.fileList[0].url;
			}
			return '';
		  }
		},
		mounted() {
			console.log(Constants.BASE_URL) 
			this.update_url = Constants.BASE_URL
		},
		methods: {
			...mapActions(['login', 'logout']),
			//文件上传成功时的钩子
			handleAvatarSuccess(res, file) {
				this.isUploading = false;
				this.uploadPercent = 0;
				console.log(res,11)
				console.log(file,22)
				if(res.code ==1){
					this.fileList=[{name: file.name, url: res.data.fullurl}]
					this.ruleForm.license_url=res.data.url
				}
				console.log(this.fileList,33);
				//this.imageUrl = URL.createObjectURL(file.raw);
			  },
			  handleProgress(event, file, fileList) {
				this.uploadPercent = Math.floor(event.percent);
			  },
			  handleAvatarError(err, file, fileList) {
				this.isUploading = false;
				this.uploadPercent = 0;
				this.$message.error('업로드 실패했습니다. 다시 시도해주세요.');
			  },
			//文件列表移除文件时的钩子
			handleRemove(file, fileList) {
				console.log(file, fileList,3333333333333333);
				this.fileList=[]
				this.ruleForm.license_url=''
				//服务器上删除图片
				
			  },
			  //点击文件列表中已上传的文件时的钩子	
			  handlePreview(file) {
				console.log(file,2222222222);
				console.log(file.response.data.fullurl,2222222222);
				console.log(this.ruleForm.fileList,2222222222);
				window.open(this.ruleForm.fileList[0].url, '_blank');
			  },
			  //文件超出个数限制时的钩子
			  handleExceed(files, fileList) {
				//this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
				this.$message.warning(`현재 파일 1개만 선택 가능합니다. 이번에 선택한 파일은 ${files.length}개이고, 총 선택한 파일은 ${files.length + fileList.length}개입니다.`);
			  },
			  //删除文件之前的钩子，参数为上传的文件和文件列表，若返回 false 或者返回 Promise 且被 reject，则停止删除
			  beforeRemove(file, fileList) {
				return this.$confirm(`정말 삭제하시겠습니까?`);
			  },
			  removeLicense() {
				this.fileList = [];
				this.ruleForm.license_url = '';
			  },
			  handlePreviewImage() {
				if (this.licenseFullUrl) {
					window.open(this.licenseFullUrl, '_blank');
				}
			  },
			  onBirthdayChange() {
				if (this.birthYear && this.birthMonth && this.birthDay) {
					const month = this.birthMonth.toString().padStart(2, '0');
					const day = this.birthDay.toString().padStart(2, '0');
					this.ruleForm.birthday = `${this.birthYear}-${month}-${day}`;
				} else {
					this.ruleForm.birthday = '';
				}
			  },
			  filterBizNumber(val) {
				this.ruleForm.biz_number = val.replace(/-/g, '');
			  },
			  //上传文件之前的钩子
			  beforeAvatarUpload(file) {
				  this.isUploading = true;
				  this.uploadPercent = 0;
				  const isPt = (file.type === 'image/jpeg' || file.type === 'image/png');
				  const isLt10M = file.size / 1024 / 1024 < 10;
		  
				  if (!isPt) {
					this.$message.error('이미지 파일(JPG/PNG)만 업로드 가능합니다!');
				  }
				  if (!isLt10M) {
					this.$message.error('파일 크기는 10MB를 초과할 수 없습니다!');
				  }
				  return isPt && isLt10M;
				},
			  
			// changeBusiness(e){
			// 	console.log(e,"更新后的值")		
			// },
			goCustomsinfoUrl(url){			
				//window.location.href = url;
				window.open(url, '_blank');
			},
			submitForm(formName) {
				console.log(formName)
				console.log(this.ruleForm.service,123)
				console.log(this.ruleForm.information,123)
				if(this.ruleForm.service == '동의안함'){
					alert("동의해주세요 서비스 이용약관")
					return
				}
				if(this.ruleForm.information == '동의안함'){
					alert("동의해주세요 개인정보 수집 및 이용")
					return
				}
				console.log(this.ruleForm.business,"是否是商家")
				if(this.ruleForm.business){//注册商家时
					this.ruleForm.identity=2
					if(this.ruleForm.biz_company == ''){
						alert("상호명 비울 수 없습니다")
						return
					}
					if(this.ruleForm.biz_number == ''){
						alert("사업자등록번호 비울 수 없습니다")
						return
					}
					if(this.ruleForm.biz_ceo == ''){
						alert("대표자명 비울 수 없습니다")
						return
					}
					if(this.fileList=='' && !this.ruleForm.license_url){
						alert("사업자등록증 비울 수 없습니다")
						return
					}
				}else{
					this.ruleForm.identity=1
				}
				
				if(this.ruleForm.gender=="남자"){
					this.ruleForm.gender=1
				}else{
					this.ruleForm.gender=0
				}
				if(this.fileList && this.fileList.length > 0){
					this.ruleForm.fileList = this.fileList[0]
				}
		
				this.$refs[formName].validate((valid) => {
				  if (valid) {
					  request.post('/User/register',
					  	this.ruleForm
					  ).then(response => {
						  console.log(response,"注册")			  
					  	if(response.code ==1){
							this.$message({
								message: `회원가입 제출 성공! 성함: ${this.ruleForm.nickname}`,
								type: 'success',
								duration: 5000
							});
							console.log('注册提交成功,稍后审核通过即可登录！');
							setTimeout(() => {
								this.$router.replace('/');
							}, 1500);
							// const userinfo = response.data.userinfo; 
							// try {
							// 	this.login({ //await 
							// 	  token: userinfo.token,
							// 	  nickname: userinfo.nickname,
							// 	});
							// 	console.log('登录成功！');
							// 	this.$router.replace('/');
							// 	//alert("登录成功")
							//   } catch (error) {
							// 	console.error('登录失败:', error);
							//   }

					  	}else{
					  		alert(response.msg)
					  		return
					  	}
					  		
					  });
					  
					  
					  console.log(this.ruleForm,"提交")
					
				  } else {
					console.log('error submit!!');
					return false;
				  }
				});
			  },
			  onReturn(){
				 safePush(this.$router, '/login');
			  }
			 //  resetForm(formName) {
				// this.$refs[formName].resetFields();
			 //  }
		
		}
		
		
	}
</script>

<style scoped>
	.register .title{
		font-size: 45px;
		text-align: center;
		font-weight: bold;
		margin: 0 0 103px;
	}
	.register h4{
		font-size: 24px;
		font-weight: bold;
		margin-bottom: 21px;
	}
	.agreement-box{
		border: 1px solid var(--border-color);
		background: #F5F8FD;
		padding: 30px;
		margin-bottom: 9px;
		border-radius: 20px;
	}
	.height-fixed-box{
		background: #F5F8FD;
		height: 270px;
		overflow-y: scroll;
		padding-right: 20px;
		font-size: 12px;
		color: #333;
	}
	.border-bottom{
		font-size: 24px;
		font-weight: bold;
		margin-bottom: 21px;
		padding-bottom: 15px;
		border-bottom: 1px solid #333;
	}
	.from-main{
		padding:0 5px;
	}
	.from-title{
		padding:10px 0;
	}
	.required-addon{
		font-family: inherit;
		color: var(--main-color);
		font-weight: inherit;
		vertical-align: inherit;
	}
	.help-block{
		margin-top: 8px;
		font-size: 15px;
		color: var(--font-color);
		line-height: 1.4;
	}
	.customs_button{
		color: var(--main-color); 
		display: inline-flex;
		justify-content: center;
		align-items: center;
		border-radius: 19px;
		font-weight: 600;
		font-size: 12px;
		text-transform: uppercase;
		text-decoration: none !important;
		border: 1px solid var(--main-color);
		padding: 7px 17px;
		transition: 0.25s;
		line-height: normal;
		margin: 10px 0 0 10px;
	}
	.extend-biz{
		position: relative;
	}
	.extend-biz > span{
		font-size: 15px;
		font-weight: 500;
		color: var(--main-color);
		line-height: 23px;
		position: absolute;
		right: 0;
		top: -10px;
		text-align: right;
	}
	
	@media (min-width:800px) {
		.register{
			width: 800px;
			margin: 2.5rem auto;
		}
		.from-main, .extend-biz {
			width: 600px;
			margin: 0 auto;
		}
		.from-title {
			padding-right: 15px;
			text-align: right;
		}
		.biz-checkbox-large {
			justify-content: center;
		}
	}
	@media (max-width: 768px) {
		.register .title{
			text-align: center;
			font-size: 30px;
			font-weight: bold;
			margin: 30px 0;
		}
		.register h4{
			text-align: center;
		}
		.help-block{
			padding-top: 5px;
			font-size: 14px;
			color: var(--font-color);
		}
		
		.extend-biz > span{
			color: var(--main-color);
		    font-size: 13px;
		    margin-top: 10px;
		    font-weight: normal;
		    line-height: 20px;
		    display: block;
		} 
	}
	.referral-benefit-tip {
		margin-top: 15px;
		padding: 12px 15px;
		background-color: #fdf6ec;
		border-left: 5px solid #e6a23c;
		color: #e6a23c;
		font-size: 13px;
		display: flex;
		align-items: center;
		border-radius: 4px;
	}
	.referral-benefit-tip i {
		font-size: 18px;
		margin-right: 8px;
	}
	.birthday-selects {
		display: flex;
		align-items: center;
	}
	.biz-checkbox-large /deep/ .el-checkbox__inner {
		width: 24px;
		height: 24px;
	}
	.biz-checkbox-large /deep/ .el-checkbox__inner::after {
		height: 12px;
		left: 8px;
		top: 2px;
		width: 5px;
	}
	.biz-checkbox-large /deep/ .el-checkbox__label {
		font-size: 18px;
		font-weight: bold;
		color: #333;
		padding-left: 12px;
	}
	.license-thumbnail {
		margin-top: 15px;
	}
	.thumbnail-wrapper {
		position: relative;
		width: 150px;
		height: 150px;
		border: 1px solid #dcdfe6;
		border-radius: 8px;
		overflow: hidden;
		cursor: pointer;
	}
	.thumbnail-wrapper img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.thumbnail-overlay {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, 0.6);
		color: #fff;
		height: 35px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 13px;
		transition: opacity 0.3s;
	}
	.thumbnail-wrapper:hover .thumbnail-overlay {
		background: rgba(231, 76, 60, 0.8);
	}
	.thumbnail-overlay i {
		margin-right: 5px;
	}
	/* 隐藏电话号码输入框的上下递增/递减按钮 */
	.phone-input input::-webkit-outer-spin-button,
	.phone-input input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	.phone-input input[type="number"] {
		-moz-appearance: textfield;
	}
</style>